import apiClient from '../ApiClient';

export const updateReview = async (
  id: number,
  payload: {
    rating: number;
    comment: string;
  }
): Promise<any> => {
  const res = await apiClient.put(`reviews/${id}`, payload);

  return res.data;
};